import {
  Alert,
  AlertIcon,
  AlertDescription,
  useColorModeValue,
  CloseButton,
  Box,
} from "@chakra-ui/react";
import { useState } from "react";
import { useNavigate } from "react-router";
import { useIntegrationListQuery } from "features/Integrations/hooks";
import { useCanManageIntegrations } from "hooks/useCurrentUserPermissions";
import { Integration } from "models/integration";
import { PEOPLE_TEAM_ROUTES } from "definitions/constants/routeConstants";

export default function CalendarReauthBanner() {
  const canManageIntegrations = useCanManageIntegrations();
  const [isDismissed, setIsDismissed] = useState(false);
  const navigate = useNavigate();
  const alertTextColor = useColorModeValue("fg.subtle", "inherit");

  const { data: integrations } = useIntegrationListQuery({
    enabled: canManageIntegrations,
    staleTime: 1000 * 60 * 3,
  });

  const calendarNeedsReauth = (integrations || []).some(
    (integration: Integration) => integration.partner === "google_calendar" && integration.needsReauth,
  );

  const shouldShow = canManageIntegrations && calendarNeedsReauth && !isDismissed;

  if (!shouldShow) return null;

  const handleClick = () => {
    navigate(PEOPLE_TEAM_ROUTES.company.integrations.index);
  };

  return (
    <Alert status="error" cursor="pointer" onClick={handleClick} transition="background-color 0.2s" position="relative">
      <AlertIcon />
      <Box flex="1">
        <AlertDescription color={alertTextColor} fontSize="sm">
          Google Calendar is disconnected — meeting scheduling is paused. Click to reconnect from the Integrations page.
        </AlertDescription>
      </Box>
      <CloseButton
        position="absolute"
        right="8px"
        top="8px"
        onClick={(e) => {
          e.stopPropagation();
          setIsDismissed(true);
        }}
      />
    </Alert>
  );
}
